﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Abbonamento",
  "change": "Cambia",
  "currency": "USD",
  "save": "Salva",
  "save17Percent": "<strong>Risparmia {{percent}}%</strong> con un'opzione annuale",
  "save17PercentNoBold": "Risparmia {{percent}}%",
  "yearly": "Annuale",
  "monthly": "Mensilmente",
  "Lifetime": "Per sempre",
  "PerMonth": "Per mese",
  "PerYear": "Per anno",
  "Free": "Gratis",
  "optional": "opzionale",
  "trialLengthTrial": "<0>{{ trialLength }}</0>giorni di prova",
  "viewAllPlans": "Vedi tutte le Opzioni",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canada",
  "unitedStates": "Stati Uniti",
  "oneMomentPlease": "Un momento per favore...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Completo",
  "loadingRegions": "Caricamento regioni disponibili",
  "loadingPartners": "Caricamento partner disponibili",
  "supportedPeripherals": "Periferiche supportate",
  "pleaseWait": "Attendere...",
  "minimum": "Minimo",
  "recommended": "Consigliato",
  "browser": "Browser",
  "tobiiDynavoxEyeTrackers": "Eye Tracker Tobii Dynavox",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "bisogno di aiuto nella scelta",
  "or": "oppure",
  "advantages": "Vantaggi",
  "visitPartnerSite": "Visita il sito partner",
  "recentOrders": "Ordini recenti",
  "current": "attuale",
  "orLater": "o successivo",
  "customerSupport": "supporto clienti",
  "proratedAmount": "Importo proporzionale",
  "community": {
    "community": "Community",
    "getStartedNow": "Inizia ora!"
  },
  "personal": "Privato",
  "professional": "Professionista",
  "planCard": {
    "noCCRequired": "Nessuna carta di credito richiesta",
    "cCOnly": "Solo carta di credito",
    "cCOrPO": "Carta di credito o ordine d'acquisto",
    "myPlan": "La mia Opzione",
    "currentPlan": "Opzione corrente",
    "downgradeNotice": "La modifica diventa effettiva una volta scaduta l'opzione corrente.",
    "upgradeNotice": "La modifica diventa effettiva immediatamente."
  },
  "selectedPlanSummary": {
    "summary": "Riepilogo",
    "change": "$t(change)",
    "subtotal": "Subtotale"
  },
  "action": {
    "joinToday": "Unisciti oggi!",
    "finish": "Fine",
    "subscribe": "Abbonati",
    "resubscribe": "Riabbonati",
    "requestAQuote": "Chiedi un preventivo",
    "try": "Prova",
    "startTrial": "Inizia prova",
    "buyNow": "Acquista ora",
    "tryIt": "Provalo",
    "tryItFree": "Provalo gratis per 30 giorni!",
    "free": "gratis",
    "getStarted": "Inizia",
    "forTrialDays": "per <1>{{trialLength}}</1> giorni",
    "comparePlans": "Confronta le Opzioni",
    "hideComparisons": "Nascondi Confronto",
    "learnMore": "Ulteriori informazioni",
    "start": "Avvio",
    "next": "Poi",
    "edit": "Modifica",
    "cancel": "Annulla",
    "imTaxExempt": "Esenzione fiscale",
    "submit": "Invia",
    "print": "Stampa",
    "backToPaymentDetails": "Torna ai dettagli del pagamento",
    "close": "Chiudi",
    "back": "Lato posteriore",
    "continue": "Continua",
    "uploading": "Caricamento",
    "delete": "Canc",
    "update": "Aggiorna",
    "generatingInvoice": "Generazione fattura",
    "proceed": "Procedi",
    "modify": "Modifica",
    "yes": "Sì",
    "signUp": "Iscriviti",
    "downloads": "Downloads"
  },
  "status": {
    "loading": "Caricamento in corso...",
    "creatingAccount": "Creazione account in corso...",
    "submitting": "Invio in corso...",
    "submittingPayment": "Invio pagamento in corso...",
    "submittingRequest": "Invio richiesta in corso..."
  },
  "planComparison": {
    "label": "Quali sono i vantaggi offerti da ciascuna opzione?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Confronto delle funzioni",
    "subheader": "La soluzione preferita dal mondo per la creazione illimitata di comunicazione basata sui simboli e supporti visivi!"
  },
  "account": {
    "email": "Posta elettronica",
    "accountFoundTitle": "Account trovato",
    "accountFoundMessage": "Esiste già un account con questa email. Accedere utilizzato tale account o utilizzare un email differente e creare un nuovo account?",
    "signedOutElsewhereTitle": "Sei stato disconnesso",
    "signedOutElsewhereMessage": "Sei stato disconnesso in un'altra scheda. Accedi di nuovo per continuare, oppure chiudi questo messaggio per continuare a navigare senza un account.",
    "signedOutElsewhereDismiss": "Continua a navigare",
    "federatedEmailTitle": "Email dell'organizzazione rilevata",
    "federatedEmailMessage": "Questo indirizzo email utilizza l'accesso dell'organizzazione. Accedere per usare Boardmaker tramite l'organizzazione oppure utilizzare un altro indirizzo email per creare un nuovo account.",
    "federatedEmailUseDifferent": "Usa un altro indirizzo email",
    "logIn": "Accedi",
    "logOut": "Esci",
    "loggingIn": "Accesso in corso...",
    "loggingOut": "Disconnessione in corso...",
    "verifying": "Verifica in corso...",
    "loggingInMessage": "Accesso in corso...",
    "createAccount": "Crea account",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Hai già un ",
    "login2": "Tobii Dynavox",
    "login3": "account",
    "loginPrompt": "Hai già un <1>account Tobii Dynavox</1>? <3>Accedi</3>",
    "cancelSubscription": "Annulla abbonamento",
    "areYouSure": "Selezionare questa opzione? Questa operazione implicherà quanto segue:",
    "cancelSubscriptionProcess": "Annulla l'elaborazione dell'abbonamento (i progressi correnti verranno persi)",
    "changeToCommunityPlan": "Cambia il tuo account con un'opzione della Community",
    "onceYouveCompletedYourProfile": "Una volta completato il profilo, se decidi di aggiornare la tua opzione, puoi farlo in qualsiasi momento dalla sezione Il mio account.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Recupero delle informazioni utente"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Compila i dettagli seguenti e ti faremo contattare a breve da un responsabile account.",
    "fillOutDetailsBelowLicense": "Compila i dettagli seguenti e ti faremo contattare a breve da un consulente alle vendite."
  },
  "forms": {
    "confirmEmail": "Email di conferma",
    "billingDetails": "Dettagli fatturazione",
    "paymentType": "Tipo di pagamento",
    "creditCardType": "Tipo di pagamento",
    "creditCard": "Carta di credito",
    "purchaseOrder": "Ordine d'acquisto",
    "cardNumber": "Numero carta",
    "expirationDate": "Data di scadenza",
    "cardholderName": "Nome intestatario carta",
    "cardSecurityCode": "Codice di sicurezza carta",
    "securityCode": "Codice di sicurezza",
    "organizationName": "Nome azienda",
    "accountsPayableEmail": "Email per invio Fattura",
    "firstName": "Nome",
    "lastName": "Cognome",
    "addressLine": "Riga indirizzo 1",
    "addressLine2": "Riga indirizzo 2",
    "country": "Paese",
    "language": "Lingua",
    "city": "Città",
    "stateProvinceRegion": "Stato / Provincia / Regione",
    "zipPostalCode": "CAP / Codice postale",
    "month": "Mese",
    "year": "Anno",
    "optional": "opzionale",
    "username": "Nome utente",
    "name": "Nome",
    "phoneNumber": "Numero di telefono",
    "phone": "Telefono",
    "email": "Posta elettronica",
    "url": "URL",
    "selectYourCountry": "Seleziona paese",
    "selectYourState": "Seleziona stato",
    "selectYourProvinceTerritory": "Seleziona provincia o territorio",
    "selectYourTerm": "Seleziona termine",
    "1year": "1 anno",
    "2years": "2 anni",
    "3years": "3 anni",
    "4years": "4 anni",
    "5years": "5 anni",
    "instructorLogins": "Numero di accessi istruttore",
    "studentLogins": "Numero di accessi studente",
    "term": "Termine",
    "tradeIn": "Idoneo per uno sconto commerciale?",
    "legacyVersions": "Hai versioni legacy di Boardmaker da permutare in cambio di uno sconto sul costo di myBoardmaker?",
    "selectAResponse": "Seleziona una risposta",
    "yes": "Sì",
    "no": "No",
    "notSure": "Non ne sono sicuro",
    "password": "Password",
    "confirmPassword": "Conferma password",
    "additionalInformationOrQuestions": "Informazioni aggiuntive o domande",
    "countryNotSupported": "---",
    "uploadDocument": "Carica documento",
    "chooseFile": "Scegli file",
    "paymentMethod": "Metodo di pagamento",
    "purchaseOrdersAreOnlyProcessed": "Gli ordini d'acquisto vengono elaborati solo dopo aver inoltrato l'ordine, pertanto, prima di allora, sono modificabili in qualsiasi momento.",
    "PONumber": "Numero ordine d'acquisto",
    "PONotes": "Dati Azienda",
    "iVerifyThatImAuthorized": "Ho verificato e sono autorizzato a inviare questo ordine d'acquisto.",
    "submissionSuccessful": "Invio riuscito correttamente!",
    "thankYourForYourRequest": "Grazie per la richiesta! Un responsabile account ti contatterà a breve.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Numero di licenze",
    "pleaseEnterYourName": "Inserisci esattamente il tuo nome come indicato sulla carta",
    "needHelpFindingSecurityCode": "Bisogno di aiuto per trovare il codice di sicurezza della carta?"
  },
  "validation": {
    "required": "Obbligatorio",
    "invalidEmail": "E-mail non valida",
    "emailsMustMatch": "Le email devono corrispondere",
    "passwordsMustMatch": "Le password devono corrispondere",
    "errorOccurred": "Si è verificato un errore durante l'invio del modulo",
    "tryAgain": "Riprovare. Se il problema persiste, contattare l'assistenza.",
    "errorOccurredPDF": "Si è verificato un errore durante il caricamento della fattura in PDF",
    "password": {
      "minLength": "La password deve contenere almeno 8 caratteri",
      "tooShort": "Troppo corta",
      "checking": "Controllo in corso..."
    },
    "USZipCode": "Inserisci un codice di avviamento postale US",
    "CAZipCode": "Inserisci un codice postale CA.",
    "invalidCardNumber": "Numero carta non valido",
    "invalidCardType": "Tipo carta non valido",
    "invalidExpirationDate": "Data di scadenza non valida",
    "invalidSecurityCode": "Codice di sicurezza non valido",
    "securityCodeNumericWarning": "Il codice di sicurezza deve contenere solo numeri",
    "invalidUsernameWarning": "Nome utente non valido. Deve contenere solo lettere e numeri.",
    "usernameMaxLengthWarning": "Il nome utente non può superare i 60 caratteri",
    "badZip": "Il codice postale inserito non è valido per lo stato selezionato.",
    "badPostalCode": "Il codice postale inserito non è valido per la provincia o il territorio selezionato.",
    "canadianAddressNeedsCad": "Gli indirizzi di fatturazione canadesi vengono fatturati in dollari canadesi. Per continuare, selezionare la bandiera nella parte superiore della pagina, quindi scegliere Canada."
  },
  "invoice": {
    "communityHeader": "Nessuna carta di credito. Solo accesso gratis a myBoardmaker Community. Conserva i tuoi dati e progressi se decidi di passare a un abbonamento a pagamento. Cosa stai aspettando?",
    "trialHeader": "Nessuna restrizione. Nessuna carta di credito. Conserva i tuoi dati e progressi se decidi di convertire la tua versione di prova in un abbonamento a pagamento. Cosa stai aspettando?",
    "plan": "Opzione",
    "term": "Termine",
    "price": "Prezzo",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Dettagli pagamento",
    "endingWith": "Termina con",
    "expires": "Scade",
    "orderSummary": "Riepilogo ordine",
    "orderDate": "Data ordine",
    "orderNumber": "Numero ordine",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Tassa",
    "total": "Totale",
    "aConfirmationEmail": "Un'email di conferma ordine è stata inviata a",
    "printOrderSummary": "Stampa riepilogo ordine",
    "recurringPaymentDisclaimer": "Il tuo ordine include un <strong>pagamento ricorrente</strong> del valore di <3>{{amount}}</3> che si rinnoverà il <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Ti addebiteremo <strong>{{amount}}</strong> il <strong>{{date}}</strong>, all’inizio del nuovo abbonamento.",
    "PODisclaimer": "Il tuo abbonamento è ora attivo e pronto all'uso. Per evitare interruzioni del servizio, chiediamo che il pagamento entro <strong>30 giorni</strong>. Se il pagamento non viene ricevuto entro <4>{{date, LL}}</4>, l'account sarà convertito in un account community gratuito fino al pagamento dell'importo dovuto.",
    "purchaseOrderNumber": "Numero ordine d'acquisto",
    "orgNotes": "Dati Azienda",
    "pleaseSendACopyOfYourInvoice": "Inviare il pagamento e una copia della fattura a:",
    "ifYourPurchaseOrdersReady": "Se l'ordine d'acquisto è pronto, puoi caricarlo ora.",
    "supportedFileTypes": "Tipi di file supportati: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Al momento opportuno, invieremo un'e-mail a <1>{{email}}</1> come promemoria per il pagamento successivo.",
    "uploadSuccessful": "Caricamento avvenuto correttamente!",
    "yourAccountWillContinue": "Grazie per l'ordine d'acquisto. Per i rinnovi dell'abbonamento, attendere fino a 14 giorni per consentire l'elaborazione dell'ordine. Una volta completato, sarà inviata un'email a conferma del completamento insieme alla fattura.",
    "billing": "Indirizzo di fatturazione",
    "payment": "Metodo di pagamento",
    "ifYourPurchaseOrderIsReady": "Se l'ordine d'acquisto è pronto, puoi caricarlo ora.",
    "PODisclaimer1": "Il tuo abbonamento è ora attivo e pronto all'uso.",
    "PODisclaimer2": "Il pagamento deve essere ricevuto entro 30 giorni, in caso contrario il tuo account sarà convertito automaticamente in un account community gratuito.",
    "POStartsLaterDisclaimer": "Ti invieremo la fattura il <strong>{{date}}</strong>, all’inizio del nuovo abbonamento. Il pagamento è dovuto entro 30 giorni da tale data."
  },
  "legal": {
    "privacyPolicy": "Informativa sulla privacy",
    "studentPolicy": "Informativa sui dati degli studenti",
    "termsAndConditions": "Termini e condizioni",
    "termsOfService": "Termini del servizio",
    "tdTermsAndConditions": "Accetto Tobii Dynavox <1>$t(legal.termsAndConditions)</1>",
    "contactUs": "Contattaci"
  },
  "errors": {
    "error": "Errore",
    "loadingPlans": "Caricamento opzioni",
    "sorry": "Purtroppo...non sei tu...siamo noi",
    "somethingWentWrong": "C'è stato un problema dalla nostra parte. Abbiamo registrato questo errore e ti chiediamo di <1>{{link}}</1> nel caso in cui questo problema dovesse verificarsi nuovamente.",
    "tryGoingBack": "Prova ad andare indietro o <1>{{link}}</1>",
    "downloadList": "Impossibile caricare l'elenco dei download."
  },
  "404": {
    "sorry": "Purtroppo non è stato possibile trovare quella pagina",
    "oldLink": "Potrebbe trattarsi di un link datato o potrebbe essere stato spostato.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Inizia ora la versione di prova gratuita!",
    "startYourFreeTrial": "Avvia la versione di prova gratuita",
    "todayWhichIncludesAccessForThirtyDays": " oggi che include l'accesso per 30 giorni!"
  },
  "navigation": {
    "bmoRedirect": "Reindirizzamento a myBoardmaker in corso..."
  },
  "expired": {
    "expiredTrialText": "Ci auguriamo abbia gradito l'anteprima senza limiti di 30 giorni. La versione di prova è stata convertita in un'opzione Community gratuita e tutti i dati e i progressi* sono stati salvati. Per accedere alle funzioni premium disponibili durante la versione di prova, effettuare l'aggiornamento a un abbonamento mensile o annuale.",
    "dataAndProgress": "* I dati e i progressi inclusi nelle funzioni premium sono accessibili solo con un abbonamento a pagamento completo."
  },
  "currencySelector": {
    "header": "Seleziona il paese e la lingua",
    "disclaimer": {
      "USD": "Se il paese non è presente nell'elenco, selezionare Stati Uniti d'America"
    }
  },
  "taxExempt": {
    "us&ca": "Solo Stati Uniti e Canada",
    "taxExemptionProgram": "Inviare i documenti di esenzione fiscale tramite questo modulo. Ti contatteremo tramite email entro 3 giorni lavorativi per confermare il tuo stato di esenzione fiscale. Dopo aver ricevuto l'email di conferma, potrai effettuare l'ordine con esenzione fiscale. Se effettui l'ordine prima di ricevere l'email di conferma, ti verranno addebitate tasse non rimborsabili.",
    "taxExemptionProgramExisting": "Inviare i documenti di esenzione fiscale tramite questo modulo. Ti contatteremo tramite email entro 3 giorni lavorativi per confermare il tuo stato di esenzione fiscale. Dopo aver ricevuto l'email di approvazione, gli acquisti futuri e i rinnovi dell'abbonamento non saranno tassati. Le tasse pagate sugli acquisti effettuati prima di ricevere l'email di conferma di esenzione fiscale non sono rimborsabili.",
    "yourSubmissionWasSuccessfulNew": "Invio eseguito correttamente. Il nostro staff rivedrà la tua documentazione e dovresti ricevere un'email di notifica entro 3 giorni lavorativi a conferma della corretta elaborazione della tua richiesta. Una volta accettata, sarà possibile completare l'ordine esentasse. Nel frattempo, abbiamo creato per te un account Community gratuito per iniziare a esplorare tutto ciò che myBoardmaker ha da offrire.",
    "yourSubmissionWasSuccessfulExisting": "Invio eseguito correttamente. Il nostro staff rivedrà la tua documentazione e dovresti ricevere un'email di notifica entro 3 giorni lavorativi a conferma della corretta elaborazione della tua richiesta. Una volta accettata, sarà possibile completare il pagamento successivo esentasse."
  },
  "modify": {
    "contactCustomerSupport": "Contattare <1>{{supportLink}}</1> per modificare l'abbonamento",
    "billingDetails": "Modifica dettagli di fatturazione",
    "paymentModalHeader": "Aggiornamento effettuato correttamente!",
    "paymentModalBody": "Le modifiche apportate saranno effettive a partire dal prossimi ciclo di fatturazione.",
    "thankYou": "Grazie per il pagamento!",
    "daysRemaining": "giorni rimanenti",
    "dueDisclaimer": "Se il pagamento non viene ricevuto entro 30 giorni dalla data del rinnovo, l'account sarà convertito in un account community gratuito fino al pagamento dell'importo dovuto.",
    "lateDisclaimer": "Per evitare l'interruzione dell'abbonamento, pagare per intero l'importo. Se il pagamento non viene ricevuto, l'account sarà convertito in un account community gratuito fino al pagamento dell'importo dovuto.",
    "nextPaymentDueIn": "Prossimo pagamento entro",
    "days": "giorni",
    "paymentIs": "Il pagamento è scaduto da",
    "daysPastDue": "giorni",
    "recurringPaymentDisclaimer": "Il tuo <1>planOrOrder</1> include un <strong>pagamento ricorrente</strong> del valore di <4>{{amount}}</4> che si rinnoverà il <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "La tua opzione include un <strong>pagamento ricorrente</strong> che si rinnoverà il <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "È possibile inviare l'ordine d'acquisto utilizzando uno dei metodi descritti di seguito. Contatta il nostro team di assistenza clienti per riattivare il tuo abbonamento.",
    "yourAccountHasBeenConverted": "Il tuo account a pagamento viene convertito in un account Community gratuito",
    "balanceDueIn": "Importo dovuto fra",
    "subscriptionExpiresIn": "L'abbonamento scade fra",
    "paymentPastDue": "Pagamento scaduto",
    "autoRenewal": "Rinnovo automatico",
    "turnAutoRenewOff": {
      "header": "Disabilita il rinnovo automatico dell'abbonamento",
      "areYouSure": "Disattivare il rinnovo automatico? Questa operazione implicherà quanto segue:",
      "points": [
        "Annulla l'abbonamento a pagamento alla fine del ciclo di fatturazione corrente.",
        "Converti l'account in un'opzione Community gratuita alla fine del ciclo di fatturazione corrente.",
        "Avrai accesso al tuo contenuto dopo la conversione e potrai abbonarti nuovamente in qualsiasi momento per riottenere l'accesso alle funzioni premium offerte dagli abbonamenti a pagamento. ",
        "Se dovessi cambiare idea prima del termine dell'abbonamento corrente, sarà sufficiente riattivare il rinnovo automatico."
      ],
      "footer": "Disabilitare il rinnovo automatico?"
    },
    "turnAutoRenewOn": {
      "header": "Abilita il rinnovo automatico dell'abbonamento",
      "areYouSure": "Caratteristiche del rinnovo automatico dell'abbonamento:",
      "points": [
        "Il tuo abbonamento è impostato per rinnovarsi automaticamente al termine del periodo di abbonamento corrente.",
        "Pagamento senza scocciature utilizzando il metodo di pagamento memorizzato.",
        "Ti invieremo un'email con la ricevuta ad ogni rinnovo dell'abbonamento.",
        "Come sempre, puoi modificare le impostazioni dell'abbonamento in qualsiasi momento in Dettagli della mia opzione.",
        "Hai cambiato idea? Disabilita il rinnovo automatico prima della fine dell'ultimo giorno del periodo di abbonamento corrente e non ti sarà addebitato nulla."
      ],
      "footer": "Abilitare il rinnovo automatico?"
    },
    "on": "Attivato",
    "off": "Disattivato",
    "pending": "in sospeso",
    "plan": "Opzione",
    "term": "Termine",
    "effective": "Effettivo",
    "subscription": "Abbonamento",
    "downgradeWarning": {
      "title": "Effettua il downgrade dell'abbonamento",
      "prompt": "Selezionare questa opzione? Questa operazione implicherà quanto segue:",
      "planChange": "Effettua il downgrade della tua opzione da Professionista a Privato alla fine del ciclo di fatturazione corrente",
      "termChange": "Effettua il downgrade del tuo termine da Annuale a Mensile alla fine del ciclo di fatturazione corrente",
      "changeNote": "Le modifiche apportate saranno effettive a partire dal prossimi ciclo di fatturazione.",
      "termChangeMultiToYearly": "Effettua il downgrade del tuo termine pluriennale a un termine Annuale alla fine del ciclo di fatturazione corrente",
      "termChangeMultiToMonthly": "Effettua il downgrade del tuo termine a Mensile alla fine del ciclo di fatturazione corrente"
    },
    "futureAmendmentThankYou": "Queste modifiche saranno effettive allo scadere del ciclo di fatturazione corrente. Una volta applicate queste modifiche al tuo account, sarà disponibile una fattura. Se desideri annullare una modifica in sospeso, contatta l'<1>assistenza clienti</1>.",
    "futureAmendmentDisclaimer": "La tua opzione corrente <1>{{planName}}</1> scadrà il <3>{{startEndDate}}</3>. La tua opzione <5>{{selectedPlanName}}</5> si avvierà il <7>{{startEndDate}}</7> il rinnovo automatico <9>{{term}}</9>.",
    "modificationPending": "Modifica opzione in sospeso",
    "paymentDeclined": "La transazione del rinnovo abbonamento è stata rifiutata. Modifica il metodo di pagamento entro <1>{{date}}</1>, in caso contrario il tuo abbonamento sarà annullato.",
    "continueSubscription": "Il tuo abbonamento scadrà il <1>{{ date1 }}</1>. Se desideri prolungare il tuo abbonamento per un altro {{term}}, attiva il Rinnovo automatico entro <5>{{ date2 }}</5> ed elaboreremo il pagamento il giorno successivo.",
    "discontinuedRatePlan": "La tua opzione di abbonamento corrente non è più disponibile. Scegli un'altra opzione.",
    "cancelYourSubscription": "Se desideri annullare il tuo abbonamento e ricevere un rimborso completo, contatta prima <1>{{supportLink}}</1> <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Modifica abbonamento",
    "cancelCardText": "Puoi annullare il tuo abbonamento in qualsiasi momento. Ma ci piacerebbe che restassi con noi.",
    "cancelConfirmTitle": "Sei sicuro di voler annullare il tuo abbonamento?",
    "cancelConfirmIntro": "La tua opzione corrente resterà attiva fino al <strong>{{date}}</strong>. Al termine della tua opzione:",
    "cancelConsequences": [
      "Perderai l'accesso alle funzionalità premium.",
      "Perderai i vantaggi esclusivi disponibili con il tuo abbonamento.",
      "I vantaggi del tuo abbonamento termineranno alla scadenza della tua opzione corrente."
    ],
    "keepSubscription": "Mantieni il mio abbonamento",
    "confirmCancel": "No, voglio annullare",
    "cancelledTitle": "Il tuo abbonamento è stato annullato!",
    "cancelledBody": "Il tuo abbonamento è stato annullato. Non avrai accesso al tuo account premium dopo il {{date}}.",
    "cancelledFarewell": "Ci dispiace vederti andare via! Puoi tornare quando vuoi.",
    "done": "Fine",
    "cancelledNotice": "Il tuo abbonamento <strong>{{planName}}</strong> corrente scadrà il <strong>{{date}}</strong>. Rinnova il tuo abbonamento per continuare a usufruire delle nostre funzionalità premium.",
    "resubscribedNotice": "Il tuo nuovo abbonamento <strong>{{planName}}</strong> inizierà il <strong>{{date}}</strong>, alla scadenza di quello corrente."
  },
  "tdAccount": {
    "title": "Account Tobii Dynavox",
    "header": "Cos'è un account Autenticazione unica Tobii Dynavox?",
    "body": "Il tuo account Attivazione unica Tobii Dynavox, comprensivo di un indirizzo email e di una password, è il tuo account per accedere a tutti i nostri siti Web o app. Insieme ai miglioramenti in termini di sicurezza, l'Attivazione unica fornisce un accesso più rapido e pratico ai contenuti presenti in tutti i servizi Tobii Dynavox.",
    "haveA": "Hai un",
    "tobiiDynavoxAccount": "account Tobii Dynavox?"
  },
  "redirectPageTitle": {
    "homePage": "Pagina iniziale",
    "profileCreation": "Creazione profilo"
  },
  "download": {
    "downloadBoardmaker": "Scarica Boardmaker",
    "downloadBoardmakerStudentCenter": "Scarica Boardmaker Student Center",
    "downloadOtherVersions": "Scarica altre versioni",
    "downloadBoardmakerStudio": "Scarica Boardmaker Studio",
    "licenseKey": "Codice Licenza",
    "download": "Scarica",
    "licenseHelper": "Gestore Licenza",
    "discontinued": "Eliminato il <1>{{discontinueDate}}</1>. Vedi i <3>requisiti di sistema</3>.",
    "mainFeatures": "Funzioni principali",
    "compatibility": "Compatibilità",
    "improvements": "Miglioramenti",
    "bugFixes": "Correzioni degli errori",
    "version": "Versione",
    "discontinuedSupport": "Supporto eliminato",
    "releaseDate": "Rilasciato {{date}}",
    "discontinuedDate": "Eliminato {{date}}",
    "viewSystemRequirements": "Visualizza <1>{{guideLink}}</1> per i requisiti di sistema.",
    "boardmakerSummary": "Selezionare il pulsante in basso per scaricare la versione più aggiornata di Boardmaker Editor, utilizzato per creare e modificare le attività.  Il programma di installazione funziona per tutti i tipi di account e lingue supportate.",
    "studentCenterSummary": "Selezionare il pulsante in basso per scaricare la versione più aggiornata di Boardmaker Student Center, utilizzato per riprodurre le attività di Boardmaker. Il programma di installazione funziona per tutti i tipi di account e lingue supportate.",    
    "boardmakerIntro": "Boardmaker 7 Editor è lo strumento principale che aiuta educatori, terapisti e genitori a creare, modificare e condividere le attività di Boardmaker.  Supporta l'apprendimento e la comunicazione in classe, in sala di terapia e a casa con una vasta gamma di materiale personalizzabile.",
"studentCenterIntro": "In abbinamento ad alcuni tipi di abbonamento Boardmaker 7, gli insegnanti possono assegnare attività agli studenti nell'app Boardmaker 7 Student Center e seguirne i progressi.  Gli studenti possono utilizzare l'app a casa o a scuola per completare le relative attività.",
"boardmakerStudioIntro": "Boardmaker Studio consente alle persone che assistono studenti con disabilità di creare e modificare le attività per aiutare gli studenti nell'apprendimento e nella comunicazione utilizzando simboli, testo, sintesi vocali e vocalizzazione registrata.",
"mobilePlayerIntro": "In abbinamento ad alcuni tipi di abbonamento Boardmaker, gli insegnanti possono assegnare attività agli studenti nell'app Boardmaker Student Center e seguirne i progressi.  Gli studenti possono utilizzare l'app a casa o a scuola per completare le relative attività.",
    "communityStartHeader": [
      "Richiedi il tuo accesso alla Community e il tuo archivio",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker è studiato per funzionare con Boardmakeronline.com, in cui è possibile eseguire il backup dei file Boardmaker personali e accedere alla nostra Community globale. I membri della Community possono condividere le loro creazioni e scoprire nuove attività di Boardmaker dagli altri utenti. Iscriviti per un account Community gratuito per ottenere l'accesso!",
      0,
      0
    ],
    "downloadSystemRequirements": "requisiti di sistema",
    "latestMobile": "Per una migliore esperienza possibile, prova a scaricare il software da un dispositivo che soddisfi i <1>{{systemRequirements}}</1>.",
    "onThisPage": "Su questa pagina",
    "communityStart": {
      "header": "Richiedi il tuo accesso alla Community e il tuo archivio",
      "body": "Boardmaker è progettato per funzionare con myboardmaker.com. Il tuo account Boardmaker Community gratuito include:",
      "pointOne": "Archivio cloud - esegui in sicurezza il backup dei tuoi file personali Boardmaker e accedi ovunque tu sia!",
      "pointTwo": "Activities-to-Go - curriculum a tema ottimizzato e pronto per essere stampato e utilizzato.",
      "pointThree": "Accedi alla Community globale - condividi le tue creazioni e scopri nuove attività di Boardmaker degli altri utenti.",
      "footer": "Iscriviti per un account Community gratuito per ottenere l'accesso!"
    },
    "BoardmakerCompatible": "Questo dispositivo non è compatibile con il software Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Questo dispositivo non è compatibile con l'applicazione Boardmaker Student Center.",
    "BoardmakerMobile": "Le applicazioni Boardmaker non sono supportate su questo dispositivo."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "abbonamento",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licenza",
      "tolicenseText": "acquisto una tantum",
      "mainText": "Preferisci <1>{{ toggleText }}</1> o <3>{{ helpLink }}</3>?",
      "preferencedText": "Preferisci un "
    },
    "comparison": {
      "accessTo": "Accedi a quanto indicato di seguito...",
      "title": "Aiutami a scegliere",
      "titleDescription": "Uno sguardo rapido alle differenze tra l'abbonamento a myBoardmaker e al Software Boardmaker stesso.",
      "titles": {
        "investment": "Investimento",
        "includedSoftware": "Includi software",
        "softwareUpdates": "Aggiornamenti software",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Archivio Cloud",
        "curriculum": "Curriculum",
        "studentManagement": "Gestione Studenti"
      },
      "subscription": {
        "header": "Abbonamento a myBoardmaker",
        "investment": "Costo iniziale basso, opzioni di pagamento annuali o mensili",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Inclusi (2-3 volte l'anno)",
        "pcsSymbols": "Tutti i simboli, inclusi quelli nuovi ogni 2 settimane",
        "cloudStorage": ["Archivio Attività", "Archivio File Multimediali"],
        "curriculum": [
          "Boardmaker Activities to Go 10 temi x 4 unità ciascuno",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": ["Assegna attività\u00B9", "Traccia prestazioni"]
      },
      "license": {
        "header": "Solo software",
        "investment": "Acquisto una tantum del software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Aggiornamenti periodici a pagamento (ogni 2-3 anni)",
        "pcsSymbols": "Tutti i simboli disponibili al momento dell'ultima versione (abbonamento PCS presto disponibile)",
        "cloudStorage": "Archivio Attività",
        "curriculum": "Boardmaker Activities to Go 1 tema x 4 unità",
        "studentManagement": "Nessuno"
      },
      "note": "Gli utenti possono gestire e aggiungere le assegnazioni ai singoli studenti nell'opzione Abbonamento per professionisti",
      "note2": "Accesso possibile solo con Student Center Player",
      "note3": "Gli utenti possono gestire e aggiungere le assegnazioni ai singoli studenti nell'opzione Abbonamento per professionisti",
      "localizationNoteOne": "Le app di Boardmaker 7 sono disponibili nelle seguenti lingue sia per gli utenti abbonati sia per quelli perpetui (solo software)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Inglese (US)",
        "Spagnolo",
        "Tedesco",
        "Svedese",
        "Finlandese",
        "Russo",
        "Danese",
        "Norvegese",
        "Francese",
        "Italiano",
        "Polacco",
        "Portoghese"
      ],
      "localizationNoteTwo": "Il curriculum e il sito Web myBoardmaker.com sono disponibili solo in inglese."
    }
  },
  "systemRequirements": "Requisiti di sistema",
  "releaseNotes": "Note sulla versione ", 
  "operatingSystem": {
    "title": "Sistema operativo",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Sconosciuto"
  },
  "perpetual": {
    "trial": {
      "intro": "Nessuna carta di credito. Nessun impegno. Solo <1>{{trialLength}}</1> giorni consecutivi di accesso illimitato al nostro software Boardmaker più aggiornato. Dopo aver scaricato e installato il software sul computer, puoi richiedere una chiave di attivazione di <3>{{trialLength}}</3> giorni<5>*</5> all'interno del software.",
      "footnote": "<0>*</0>Le versioni di prova iniziano il giorno in cui il software viene attivato e rimarranno attive per <2>{{trialLength}}</2> giorni consecutivi.",
      "downloadFootnote": "<0>v{{version}}</0> include le funzioni e le correzioni più recenti. Vedi i <2>requisiti di sistema</2>."
    },
    "thankyou": {
      "intro": "Cerca l'email di conferma ordine contenente i link per il download di Boardmaker e la chiave di attivazione. Abbiamo anche fornito le informazioni seguenti. Scarica e installa Boardmaker sul computer, quindi utilizza la chiave di attivazione per attivare il software. Una volta attivato, riceverai 1 anno di aggiornamenti gratuiti. <1>Assicurati di memorizzare la chiave di attivazione per gli utilizzi futuri.</1>"
    },
    "latest": "Più aggiornato",
    "legacy": "Legacy"
  },
  "countries": {
    "us": "Stati Uniti d'America"
  },
  "currencyChange": {
    "header": "Cambio valuta",
    "body": "Al momento, non è possibile acquistare abbonamenti utilizzando la valuta del paese selezionato. Se continui, la valuta passerà ai dollari statunitensi - USD."
  },
  "partner": {
    "body": "Il partner scelto o il fornitore del supporto sarà il contatto principale per tutte le domande e i problemi tecnici relativi ai prodotti.",
    "contactUs": "Se il paese presente in elenco non è corretto, ",
    "contactCustomerService": "contatta il servizio clienti."
  }
}
